module.exports = "https://payments.pagoefectivo-pre.com/Roboto-Bold.46d8b16699f2f27a6f7cea4cab9b9793.woff";